import { Controller, FieldValues, useFormState } from 'react-hook-form';
import { Select, SelectItem } from '@heroui/react';
import { FormSelectProps } from './types';

const FormSelect = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  placeholder,
  isRequired = false,
  isDisabled = false,
  description,
  className,
  options,
  showErrorOnTouched = true,
  ...rest
}: FormSelectProps<TFieldValues>) => {
  const { touchedFields, errors, isSubmitted } = useFormState({ control });
  const fieldError = errors[name]?.message as string | undefined;
  const isTouched = touchedFields[name];
  const showError = showErrorOnTouched ? (isTouched || isSubmitted) && !!fieldError : !!fieldError;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Select
          {...rest}
          label={label}
          placeholder={placeholder}
          isRequired={isRequired}
          isDisabled={isDisabled}
          description={description}
          className={className}
          selectedKeys={field.value ? [String(field.value)] : []}
          onSelectionChange={(keys) => {
            const selectedValue = Array.from(keys)[0] as string;
            field.onChange(selectedValue || undefined);
          }}
          isInvalid={showError}
          errorMessage={showError ? fieldError : undefined}
        >
          {options.map((option) => (
            <SelectItem key={option.key} textValue={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </Select>
      )}
    />
  );
};

FormSelect.displayName = 'FormSelect';

export default FormSelect;
